package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class SavingsGoalEntity(
  public val id: String,
  public val name: String,
  public val targetAmountCents: Long,
  public val savedAmountCents: Long,
  public val emoji: String?,
  public val imageUri: String?,
  public val isCompleted: Boolean,
  public val isDeleted: Boolean,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
